import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=22ce7272&scoped=true&"
import script from "./Actions.vue?vue&type=script&lang=js&"
export * from "./Actions.vue?vue&type=script&lang=js&"
import style0 from "./Actions.vue?vue&type=style&index=0&id=22ce7272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce7272",
  null
  
)

export default component.exports